import React, { Component } from "react";
import { Container, Col, Row } from "react-bootstrap";
import * as utils from "../../../utils.js";

export default class VistaDatosSacramentalesHermana extends Component {
  render() {
    let VistaSacramentales =
      this.props.DatosMonja.sister && this.props.DatosMonja.sister.baptism ? (
        <Container>
          <Row>
            <Col lg="4" className="border">
              <h6>Fecha Bautismo</h6>
              <p>{utils.formatDate(this.props.DatosMonja.sister.baptism)}</p>
            </Col>
            <Col lg="4" className="border">
              <h6>Lugar de Bautismo</h6>
              <p>{this.props.DatosMonja.sister.baptismPlace}</p>
            </Col>
            <Col lg="4" className="border">
              <h6>Diócesis</h6>
              <p>{this.props.DatosMonja.sister.diocese}</p>
            </Col>
          </Row>
          <Row>
            <Col lg="6" className="border">
              <h6>Fecha de Confirmación</h6>
              <p>{utils.formatDate(this.props.DatosMonja.sister.confirmation)}</p>
            </Col>
            <Col lg="6" className="border">
              <h6>Lugar de Confirmación</h6>
              <p>{this.props.DatosMonja.sister.confirmationPlace}</p>
            </Col>
          </Row>
        </Container>
      ) : (
        <p className="ml-3">No hay datos actualmente</p>
      );
    return <React.Fragment>{VistaSacramentales}</React.Fragment>;
  }
}
